// Logos mit transparentem Hintergrund, die auf dem Kachelgrund verschwinden (schwarz auf dunkel, weiss auf hell), werden per CSS invertiert.
// Hier wird nur gemessen: mittlere Helligkeit der sichtbaren Pixel und Deckkraft. Volle Fotos und Kacheln mit eigenem Hintergrund bleiben unberuehrt.
const measure = (img) => new Promise((resolve) => {
  const probe = new Image()
  probe.crossOrigin = 'anonymous'
  probe.onload = () => {
    try {
      const n = 48
      const c = document.createElement('canvas')
      c.width = c.height = n
      const ctx = c.getContext('2d', { willReadFrequently: true })
      ctx.drawImage(probe, 0, 0, n, n)
      const d = ctx.getImageData(0, 0, n, n).data
      let seen = 0, lum = 0
      for (let i = 0; i < d.length; i += 4) {
        const a = d[i + 3] / 255
        if (a < 0.4) continue
        seen += 1
        lum += (0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2]) / 255
      }
      resolve({ coverage: seen / (n * n), lum: seen ? lum / seen : 0.5 })
    } catch { resolve(null) }
  }
  probe.onerror = () => resolve(null)
  probe.src = img.currentSrc || img.src
})

document.querySelectorAll('.pg-tile__media:not(.pg-tile__media--cover) img').forEach(async (img) => {
  const m = await measure(img)
  if (!m || m.coverage > 0.7) return
  if (m.lum < 0.2) img.dataset.logo = 'dark'
  else if (m.lum > 0.8) img.dataset.logo = 'light'
})
